<script setup>
import { onMounted, ref, watch } from "vue";

import { useI18n } from "vue-i18n";
const { t, locale } = useI18n();



let instagramImages = ref([]);
let testimonials = ref([]);
let currentTestimonialIndex = ref(0);

const fetchInstagramImages = async () => {
  try {
    const response = await fetch(
      "https://alwayshungryfoods.com/client-project/wp-json/wp/v2/instagramimage?acf_format=standard"
    );
    const data = await response.json();

    if (data.length > 0) {
      const acf = data[0].acf;

       instagramImages.value = [
        acf.instagram_image1.simple_value_formatted,
        acf.instagram_image2.simple_value_formatted,
        acf.instagram_image3.simple_value_formatted,
        acf.instagram_image4.simple_value_formatted,
        acf.instagram_image5.simple_value_formatted,
        acf.instagram_image6.simple_value_formatted,
        acf.instagram_image7.simple_value_formatted,
        acf.instagram_image8.simple_value_formatted

      ];
    }
  } catch (error) {
    console.error("Error loading Instagram images:", error);
  }
};

const fetchTestimonials = async () => {
  try {
    const response = await fetch(
      "https://www.alwayshungryfoods.com/client-project/wp-json/wp/v2/testimonials?acf_format=standard"
    );
    const data = await response.json();
    console.log("Testimonials data:", data); 
    testimonials.value = data;
  } catch (error) {
    console.error("Error loading testimonials:", error);
  }
};

const nextTestimonial = () => {
  if (testimonials.value.length === 0) return;
  currentTestimonialIndex.value =
    (currentTestimonialIndex.value + 1) % testimonials.value.length;
};

const prevTestimonial = () => {
  if (testimonials.value.length === 0) return;
  currentTestimonialIndex.value =
    currentTestimonialIndex.value === 0
      ? testimonials.value.length - 1
      : currentTestimonialIndex.value - 1;
};

const goToTestimonial = (index) => {
  currentTestimonialIndex.value = index;
};

const fullQuote = ref("");
const displayedQuote = ref("");
let _typeIndex = 0;
let _typeTimer = null;

const clearTypeTimer = () => {
  if (_typeTimer) {
    clearTimeout(_typeTimer);
    _typeTimer = null;
  }
};

const typeQuote = () => {
  clearTypeTimer();
  if (_typeIndex < fullQuote.value.length) {
    displayedQuote.value += fullQuote.value[_typeIndex];
    _typeIndex++;
    _typeTimer = setTimeout(typeQuote, 30);
  } else {
   
    clearTypeTimer();
  }
};

const startTyping = () => {
  // reset
  clearTypeTimer();
  displayedQuote.value = "";
  _typeIndex = 0;

  fullQuote.value = t("quote");
  _typeTimer = setTimeout(typeQuote, 80);
};


const revealOnScroll = () => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        }
      });
    },
    { threshold: 0.2 } 
  );

  document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
};
const getTestimonialField = (item, fieldBase) => {
  if (!item?.acf) return "";

  // prefer language-specific suffix if available
  if (locale.value === "fr") {
    return (
      // common possibilities
      item.acf?.[`${fieldBase}_fr`]?.simple_value_formatted ||
      item.acf?.[`${fieldBase}_fr`]?.value_formatted ||
      item.acf?.[`${fieldBase}_fr`]?.value ||
      // fallback to generic
      item.acf?.[fieldBase]?.simple_value_formatted ||
      item.acf?.[fieldBase]?.value_formatted ||
      item.acf?.[fieldBase]?.value ||
      ""
    );
  } else {
    return (
      item.acf?.[fieldBase]?.simple_value_formatted ||
      item.acf?.[fieldBase]?.value_formatted ||
      item.acf?.[fieldBase]?.value ||
      // maybe explicitly stored as _en
      item.acf?.[`${fieldBase}_en`]?.simple_value_formatted ||
      item.acf?.[`${fieldBase}_en`]?.value_formatted ||
      item.acf?.[`${fieldBase}_en`]?.value ||
      // fallback to FR if nothing else
      item.acf?.[`${fieldBase}_fr`]?.simple_value_formatted ||
      item.acf?.[`${fieldBase}_fr`]?.value ||
      ""
    );
  }
};

onMounted(() => {
  startTyping();
  fetchInstagramImages();
  fetchTestimonials();
  revealOnScroll();
});
</script>

<template>
  <NavBar />

 <section class="hero">
  <div class="hero-overlay"></div>
  <img src="../assets/img/hero.jpg" alt="Always Hungry background" class="hero-bg" />
  <div class="hero-text">
   <p class="welcome">{{ $t("welcome") }}</p>
<h1 class="main-title">ALWAYS <br> HUNGRY</h1>
<p class="subtitle">{{ $t("foods") }}</p>

  </div>
 </section>

 <br>
  
<section class="cards-container reveal">

  <!-- CARD 1 — HUNGRY'S LOGO + BUTTONS -->
  <div class="card card-hungrys">
<div class="client-card">
  <a href="/hungrys"> <img src="@/assets/img/hungrys_logo_1.svg" alt="Hungry's Logo" class="hungrys-logo" /></a>
</div>
    <div class="hungrys-buttons">
      <a href="https://www.ubereats.com/ca/store/hungrys/EkSfxRRvT2OHO4oBAQnbbw?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMjMxMzAlMjBBdiUyMEJhcmNsYXklMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjI1MDAyYjkxNC0xY2QyLTVkYWUtYTU4Zi1kMzM3MjFhMTA4MzIlMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIydWJlcl9wbGFjZXMlMjIlMkMlMjJsYXRpdHVkZSUyMiUzQTQ1LjUwNjMyOCUyQyUyMmxvbmdpdHVkZSUyMiUzQS03My42MzIwNjYlN0Q%3D&ps=1" class="order-btn"><img src="@/assets/img/ubereats.png" alt=""></a>
      <a href="https://www.doordash.com/store/hungrys-montr%C3%A9al-24974949/?srsltid=AfmBOooUswH9VEkwi4v4ef4IzOprzwZfJfexa_lSq6Wx5aOmzxdklJ5 " class="order-btn"><img src="@/assets/img/doordash.png" alt=""></a>
    </div>

  </div>

  <!-- CARD 2 — CATERING -->
  <div class="card card-catering">
    <a href="/catering"><img src="@/assets/img/Catering.jpg" /></a>    

    <div class="overlay">
      <h2 class="catering-title-1">ALWAYS<br>HUNGRY</h2>
      <h3 class="catering-title-2">{{ $t("cateringTitle") }}</h3>
<a href="/catering" class="details-btn">{{ $t("reserv") }}</a>

    </div>
  </div>

  <!-- CARD 3 — VENUE -->
  <div class="card card-venue">
    <img src="@/assets/img/venuebg.png" />

    <div class="overlay">
      <h3 class="venue-script">{{ $t("venueTitle") }}</h3>

      <a href="/venue" class="details-btn">{{ $t("soon") }}</a>

    </div>
  </div>

</section>
  <!--QUOTE-->
<div class="quote">
  <h3 class="typewriter">
    {{ displayedQuote }}
  </h3>
</div>
  <section class="header">
   <h2>{{ $t("followInsta") }}</h2>

    <hr>
  </section>
  
  
<section class="gallery reveal">
  <section class="gallery">
    <ul class="slides">
      <li v-for="(img, index) in instagramImages" :key="index">
        <figure v-html="img"></figure>
      </li>
    </ul>

    <aside class="insta">
      <a href="https://www.instagram.com/alwayshungryfoods/" target="_blank">
        <i class="fa-brands fa-instagram"></i>@alwayshungryfoods
      </a>
    </aside>
  </section>
  </section>

  <section class="header">
   <h2>{{ $t("testimonials") }}</h2>

    <hr>
  </section>
  <br>
 <section class="testimonials-section">
    <article v-if="testimonials.length === 0" class="no-testimonials">
      <p>{{ $t("loadingTestimonials") }}</p>
    </article>

    <article v-else class="testimonials-slider">
      <!-- Navigation Arrows -->
      <button class="slider-arrow slider-arrow-prev" @click="prevTestimonial">
        <i class="fas fa-chevron-left"></i>
      </button>

      <button class="slider-arrow slider-arrow-next" @click="nextTestimonial">
        <i class="fas fa-chevron-right"></i>
      </button>

      <!-- Slides Container -->
      <section class="slides-container">
        <article
          v-for="(testimonial, index) in testimonials"
          :key="testimonial.id"
          class="testimonial-slide"
          :class="{ active: index === currentTestimonialIndex }"
        >
          <section class="testimonial-content">
            <div class="quote-mark">"</div>
            <blockquote class="testimonial-text">
              {{
                // getTestimonialField tries the locale-specific field first, then fallbacks
                getTestimonialField(testimonial, 'quotes') ||
                "Contenu du témoignage non disponible"
              }}
            </blockquote>
            <footer class="testimonial-author">
              <h4 class="author-name">
                -{{
                  // name might be in acf.name or post title; prefer ACF name in either language
                  getTestimonialField(testimonial, 'name') ||
                  testimonial.title?.rendered ||
                  "Anonyme"
                }}
              </h4>
              <p class="author-service">
                {{
                  getTestimonialField(testimonial, 'service') || $t("serviceFallback")
                }}
              </p>
            </footer>
          </section>
        </article>
      </section>

      <!-- Dots Indicator -->
      <nav class="slider-dots" aria-label="Navigation des témoignages">
        <button
          v-for="(testimonial, index) in testimonials"
          :key="testimonial.id"
          class="slider-dot"
          :class="{ active: index === currentTestimonialIndex }"
          @click="goToTestimonial(index)"
          :aria-label="`Aller au témoignage ${index + 1}`"
        >
        </button>
      </nav>
    </article>
  </section>


</template>


<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300..700;1,300..700&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=League+Gothic&display=swap');

</style>
<style>
html {
  scroll-behavior: smooth;
}
.reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: all 1s ease;
}

.reveal.show {
  opacity: 1;
  transform: translateY(0);
}
body{
  font-family: 'Montserrat', sans-serif;
  font-family: 'League Gothic', sans-serif;
  font-family: 'Cormorant Garamond',sans-serif;
 }
 .hero {
  position: relative;
  width: 100%;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: 5rem;
}

.hero-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(75%);
  z-index: 0;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 1;
}

.hero-text {
  position: relative;
  z-index: 2;
  text-align: center;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 0 1rem;
  transform: translateY(-10%);
}

.welcome {
  font-family: "Montserrat", sans-serif;
font-size: clamp(0.8rem, 2vw, 1.6rem);
  letter-spacing: 0.8rem;
  opacity: 0.9;
  letter-spacing: 1rem;
}

.main-title {
  font-family: "League Gothic", sans-serif;
  font-size: clamp(3rem, 10vw, 7rem);
  font-weight: 400;
  letter-spacing: 3px;
}

.main-title br{
width: 1px;

}
.subtitle {
  font-family: "Cormorant Garamond", serif;
  font-style: italic;
font-size: clamp(1.5rem, 6vw, 3.5rem);
  margin-top: 0.3rem;
  text-transform: none;
  opacity: 0.9;
}


.header h2{
font-family: 'Montserrat', sans-serif;
font-weight: 300;
font-size: clamp(1.5rem, 4vw, 2.5rem);
text-align: center;
margin-bottom: 0.5rem;
margin-top: 4rem;
color: #39383D;
}
.header hr{

 width: clamp(150px, 40vw, 400px);
  border-top: 1px solid #39383D; 
  margin: 1rem auto; 
}


/*CARDS*/ 
.cards-container { 
 display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
  width: 100%;
  margin:  0 auto;
  padding: 0;
 
} 

.card { 
  position: relative; 
 width: 100%;
  height: 70vh;
  overflow: hidden; 
  cursor: pointer; 
  transition: transform 0.3s ease; 
  margin: 0;

  
} 
.card img {
   width: 100%; 
   height: 100%; 
   object-fit: cover; 
   
  }

.overlay { 
    position: absolute; 
    bottom: 0; 
    inset: 0;
    left: 0; 
    width: 100%; 
    height: 100%;
     background: rgba(0, 0, 0, 0.55); 
     color: #fff; 
     display: flex; 
     flex-direction: column; 
     justify-content: center; 
     align-items: center; 
     transition: all 0.4s ease; 
     transform: translateY(0); 
    } 
    .card:hover .overlay { 
      transform: translateY(0); 
      height: 100%; 
    } 
    /* Floating H2 Effect */ 
    .overlay h2 {  
      letter-spacing: 1px; 
     font-size: clamp(2rem, 6vw, 2.3rem);
  font-family: 'Montserrat', sans-serif;

  color: white;
  transition: 0.3s ease; 
      font-weight: 400; 
      position: relative; 
      transform: translateY(0); 
      
       transform: translateY(-10px); 
       animation: float 3s ease-in-out infinite; 
      } 
      /* Floating animation */
       /* @keyframes float { 
        0% { transform: translateY(-20px); } 
        50% { transform: translateY(-30px); } 
        100% { transform: translateY(-20px); }
       }  */
       .details-btn {
         opacity: 1;
          color: #ffffff; 
          text-transform: uppercase; 
          font-weight: 600; 
          text-align: center; 
          font-family:'Montserrat', sans-serif ; 
          font-size: 1.8rem; 
          margin: 0; 
           padding: 0.5rem ;
  text-decoration: none;
          transition: all 0.3s ease; 
          border: 2px solid #ffffff;
          display: grid; 
          align-items: center; 

        } 
        .card:hover .details-btn 
        { 
          opacity: 1; 
        
         } 
.details-btn:hover { 
  border: 2px solid #283A54;
  color: #283A54; 
 
}
.card-hungrys {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.hungrys-logo {
  width: 55%;
  height: auto;
 
}
.card-hungrys img {
  width:50rem;
  height: auto;
  object-fit: contain;
  opacity: 0.8;
}
.hungrys-buttons {
  display: flex;
  gap: 1.5rem;
}

.order-btn {
 

 width:13rem ;
 height: auto;
}

.order-btn img {
  border-radius: 1rem;
}

.order-btn:hover {
  transform: scale(1.05);
  transition: transform 0.3s ease;
}


h2.catering-title-1 {
  font-family: "League Gothic", sans-serif;
  font-size: clamp(   3rem,  7vw, 6rem);
  line-height: 0.9;
  text-align: center;
  letter-spacing: 2px;
}

.catering-title-2 {
  font-family:"Mea Culpa", sans-serif;
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-style: italic;
  margin: 1.5rem;
  font-weight: 200;
}
.venue-script {
  font-family: "Mea Culpa", sans-serif;
  font-size: clamp(3.4rem,7vw, 7rem);
  font-style: italic;
  font-weight: 200;
  margin: 5px;
}



/*QUOTE*/
.quote{
  padding: 2rem;
}
.quote h3{
font-size: clamp(1.3rem, 4vw, 2.5rem);
font-family: 'Cormorant Garamond', serif;
font-style: italic;
color: #283A54;
font-weight: 500;
padding: 2rem;
animation-duration: 8s;
animation-direction: both;
animation-iteration-count: infinite;
}


.typewriter {
  white-space: pre-line;
  border-left: 2px solid #283A54;
  animation: caretBlink 0.7s steps(1) infinite;
}

@keyframes caretBlink {
  0%, 100% {
    border-color: transparent;
  }
  50% {
    border-color: #283A54;
  }

}

.gallery {
  
  margin: 0 auto;
  max-width: 1300px; 
  padding: 2.1rem;
}

/* Slides grid */
.slides {
 display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
  justify-content: center;
  justify-items: center;
  list-style: none;
  padding: 0;
  margin: 0 auto;
  width: 100%;
}

/* Slide item */
.slides li {
  display: block;
  width: 100%;
  overflow: hidden; 
  transition: transform 0.3s ease; 
}

.slides li figure {
  margin: 0;
  width: 100%;
  height: 100%;
  transition: transform 0.3s ease; 
}

.slides li figure img {
  width: 100%;
  height: auto;
  object-fit: cover;
  aspect-ratio: 1 / 1;
  transition: transform 0.3s ease; 
}

/* Fixed hover effect */
.slides li:hover {
  transform: scale(1.05); 
  z-index: 1; 
}

.slides li:hover figure img {
  transform: scale(1.1);
}

/* Instagram button */
.insta {
 
  margin-top: 5px;  
  display: inline-block;
  background: white;
  border: 1px solid #0a2b52;

  padding: 6px 10px;
  
}

.insta a {
  color: #0a2b52;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'Cormorant Garamond', serif;
  font-size: clamp(   1.5rem,  3vw, 0.5rem);
}

.insta i {
  font-size: 1.5rem;
}

/* Hover effect */
.insta:hover {
  background: #0a2b52;
  border-color: #0a2b52;
}

.insta:hover a {
  color: white;
}

@media (max-width: 600px) {
  .insta {
    margin: 0.3rem;
  }
}
/* TESTIMONIALS SLIDER */
.testimonials-section {
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: auto;
}

.no-testimonials {
  text-align: center;
  padding: 2rem;
  color: #666;
  font-family: 'Montserrat', sans-serif;
}

.testimonials-slider {
  position: relative;
  overflow: hidden;
  padding: 0 3rem;
  margin: 0;
  background: transparent;
  border: none;
  box-shadow: none;
}

.slides-container {
  position: relative;
  height: 300px;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
}

.testimonial-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  transform: translateX(100%);
  transition: all 0.5s ease-in-out;
  pointer-events: none;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
}

.testimonial-slide.active {
  opacity: 1;
  transform: translateX(0);
 
}

.testimonial-content {
  position: relative;
  padding: clamp(1rem, 4vw, 2.5rem);
  max-width: 800px;
  margin: 0 auto;
  border: 2px solid #0a2b52;
}

.quote-mark {
  position: absolute;
  top: -10px;
  left: 20px;
   font-size: clamp(3rem, 8vw, 6rem);
  font-family: 'Cormorant Garamond', serif;
  color: #283A54;
  opacity: 0.3;
  line-height: 1;
}

.testimonial-text {
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
   font-size: clamp(1rem, 3vw, 1.6rem);
   font-weight: 600;
  line-height: 1.6;
  color: #39383D;
  margin-bottom: 1rem;
  text-align: left;
  border: none;
  padding: 0;
  margin-left: 0;
  margin-right: 0;
}

.testimonial-author {
  text-align: left;
  border-top: none;
  padding-top: 0;
}

.author-name {
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
font-size: clamp(1rem, 3vw, 1.3rem);
  color: #283A54;
  margin: 0 0 0.3rem 0;
}

.author-service {
  font-family: 'Montserrat', sans-serif;
  font-weight: 300;
  font-size: 1rem;
  color: #666;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Navigation Arrows */
.slider-arrow {
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  color: #0a2b52;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: clamp(1.2rem, 4vw, 2rem);
  transition: all 0.3s ease;
  z-index: 10;
  background-color: #91919100;
  border: none;
}

.slider-arrow:hover {
  color: #39383D;
  transform: translateY(-50%) scale(1.1);
}

.slider-arrow-prev {
  left: 0;
}

.slider-arrow-next {
  right: 0;
}

/* Dots Indicator */
.slider-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 7rem;
}

.slider-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  background: #ddd;
  cursor: pointer;
  transition: all 0.3s ease;
}

.slider-dot.active {
  background: #283A54;
  transform: scale(1);
}



/* Responsive design */
@media (max-width: 768px) {
  .testimonials-slider {
    padding: 0 3rem;
  }
  
  .slider-arrow {
    width: 40px;
    height: 40px;
    font-size: 1.4rem;
  }
  
  .testimonial-content {
    padding: 1.5rem;
  }
  
  .slides-container {
    height: 20rem;
  }
   .card {
    height: 50vh;     
  }

  .card img {
   
    width: 100%;
    object-fit: cover;
  }

  .overlay {
    position: absolute;
   height: 100% !important;
   
 
  }
}

@media (max-width: 480px) {
.testimonials-slider {
    padding: 0 2.5rem;
  }
  
  .slider-arrow {
    width: 35px;
    height: 35px;
  }
}
@media (max-width: 1024px) {
  .main-title {
    font-size: 5rem;
  }
  .subtitle {
    font-size: 1.7rem;
  }
  .welcome {
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .hero {
    height: 80vh;
  }
  .main-title {
    font-size: 3.5rem;
  }
  .welcome {
    font-size: 0.9rem;
    letter-spacing: 10px;
  }
  .subtitle {
    font-size: 1.5rem;
  }
  .card { 
  margin-bottom: 0.5rem;
 width: 100%;
  }
  .order-btn {


 height: auto;
}
.hungrys-buttons {
 display: flex;
 flex-direction: column;
  gap: 0;
}
}

/* ---------- HEADERS ---------- */
@media (max-width: 768px) {
  .header h2 {
    font-size: 1.6rem;
  }

  .header hr {
    width: 60%;
  }
}

@media (max-width: 800px) {
  

  /* .card {
    width: 200px;
    height: 350px;
  } */


  

  .overlay h2 {
          
        margin-bottom: 5%;
  }

  .details-btn {
    font-size: 1.1rem;
   
    height: 2.8rem;
  }
}

/* ---------- QUOTE ---------- */
@media (max-width: 768px) {
  .quote h3 {
    font-size: 1.8rem;
    line-height: 1.5;
    padding: 1rem;
  }
}
@media (min-width: 2000px) {
  .slides {
    grid-auto-flow: column;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    white-space: nowrap;
    grid-template-columns: none;
  }
}
/* ---------- INSTAGRAM GALLERY ---------- */
@media (min-width: 1200px) {
  .slides {
   
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    white-space: nowrap;
  
  }
}
@media (min-width: 700px) and (max-width: 1199px) {
  .slides {
    grid-template-columns: repeat(2, minmax(200px, 1fr));
  }
}

/* ---------- TESTIMONIALS ---------- */
@media (max-width: 1024px) {
  .testimonials-slider {
    padding: 0 2rem;
  }

  .testimonial-content {
    max-width: 90%;
    margin: 0 auto;
  }
  .testimonials-section {
    padding: 1rem;
  }
}





@media (max-width: 768px) {
  .slides-container {
    height:15rem;
  }

  .testimonial-content {
    padding: 1rem;
  }

  .testimonial-text {
    font-size: 1.2rem;
    text-align: center;
  }

  .testimonial-author {
    text-align: center;
  }

  .slider-arrow {
    width: 40px;
    height: 40px;
  }
  .author-name {
    font-size: 1rem;
  }
  .author-service{
    font-size: 0.8rem;
  }
  .order-btn {
    font-size: 0.7rem;
    padding: 0.6rem 1.5rem;
  }
}

@media (max-width: 480px) {
  .cards-container {
    flex-direction: column;

  
  }

  /* .card {
    width: 260px;
    height: 350px;
  } */


  

  .overlay h2 {
            
        margin-bottom: 1rem;
  }

  .testimonial-text {
    font-size: 1rem;
  }
 
  .slider-arrow {
    width: 35px;
    height: 35px;
  }

  .slider-arrow-prev {
    left: 5px;
  }

  .slider-arrow-next {
    right: 5px;
  }
  .quote h3 {
    font-size: 1.4rem;
    line-height: 1.5;
    padding: 1rem;
  }

.quote-mark{
  font-size: 4rem;
}
}
</style>